import type { PollService } from "@busbud/core-types";

import type { SearchInfo } from "@app/types/search-types";

import { getPassengerCount } from "../search";

const hasEnoughAvailableSeats = (
  segments: (
    | PollService.API.RelatedPublicSegment
    | PollService.API.RelatedPublicSegmentV4
  )[],
  passenger_count: number
) => {
  return segments.every(({ vehicle }) => {
    return (
      vehicle.available_seats === null ||
      vehicle.available_seats >= passenger_count
    );
  });
};

export const isTripSoldOut = (
  search: SearchInfo,
  trip: PollService.API.RelatedPublicTrip | PollService.API.RelatedPublicTripV4,
  trips_segments: Record<
    string,
    | PollService.API.RelatedPublicSegment
    | PollService.API.RelatedPublicSegmentV4
  >
) => {
  const segments = trip.segment_ids.map(
    segment_id => trips_segments[segment_id]
  );
  const passenger_count = getPassengerCount(search);

  // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return !hasEnoughAvailableSeats(segments, passenger_count);
};
